import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelWithTooltip } from '@hub/features/account-dashboard/components/label-with-tooltip';
import {
  DashboardCard,
  Gauge,
  Stack,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';

interface WinLossRateCardProps {
  winRate: number;
}

export const WinLossRateCard: FC<WinLossRateCardProps> = ({ winRate }) => {
  const { t } = useTranslation('accountStatistics');

  const { isTabletOrMobile } = useBreakpoints();

  const theme = useTheme();

  return (
    <DashboardCard sx={{ maxHeight: isTabletOrMobile ? '250px' : '100%' }}>
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          alignItems: 'space-between',
        }}
        spacing={{ xs: theme.spacing(5), sm: theme.spacing(10) }}
      >
        <LabelWithTooltip
          label={t('cards.winLossRate.title')}
          tooltip={t('cards.winLossRate.tooltip')}
        />
        <Gauge
          label={t('cards.winLossRate.winRate')}
          value={Math.round(winRate * 100)}
        />
      </Stack>
    </DashboardCard>
  );
};
